import { PopoverInstance, PopoverWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { GuidedOnboardingTestIds } from '~src/home/components/GuidedOnboardingWelcomeBanner';
import { GuidedOnboardingBannerService } from '~src/home/services/GuidedOnboardingBannerService';

interface GuidedOnboardingBannerPopoverProps {
    buttonRef: React.RefObject<HTMLButtonElement>;
}

export function GuidedOnboardingBannerPopover({ buttonRef }: GuidedOnboardingBannerPopoverProps): JSX.Element {
    const popoverInstance = React.useRef<PopoverInstance>(null);

    const renderPopoverContent = () => {
        return (
            <div>
                <p>{Messages.guidedOnboardingWelcomeBanner_HeaderAdmin()}</p>
                <p>{Messages.guidedOnboardingWelcomeBanner_SubheaderAdmin()}</p>
            </div>
        );
    };

    React.useEffect(() => {
        const unsubscribe = GuidedOnboardingBannerService.instance.bannerVisibilityChanged.listenTo(({ visible, source }) => {
            const shouldShowPopover = GuidedOnboardingBannerService.instance.getPopoverVisibility();
            if (!visible && !shouldShowPopover) {
                buttonRef.current?.focus(); // focus on the help menu button when the banner is closed and the popover is not visible
            }
            if (!visible && source === 'closeButton' && shouldShowPopover) {
                popoverInstance.current.toggle(true);
                GuidedOnboardingBannerService.instance.updatePopoverVisibility(false);
            }
        });
        return unsubscribe;
    }, [buttonRef]);

    return (
        <PopoverWidget
            popoverContent={renderPopoverContent()}
            title={Messages.guidedOnboardingWelcomeBanner_HelpMenuPopover()}
            placement='bottom-start'
            ref={popoverInstance}
            triggerElement={<div />}
            darkMode={true}
            testId={GuidedOnboardingTestIds.helpMenuPopover}
            getElementToRefocus={() => buttonRef.current}
        />
    );
}
